/* outletFallbacks.js
   Single canonical Restropilots brand placeholder.
   Used when outlet thumbnail is missing (pre-onboarding state).

   Usage:
     import { getFallbackSvg } from './outletFallbacks';
     const src = getFallbackSvg();   // no argument needed — always same image
*/

const FALLBACK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 180" width="100%" height="100%">
  <defs>
    <pattern id="rp-cutlery" x="0" y="0" width="48" height="48" patternUnits="userSpaceOnUse">
      <path d="M16 6 L16 20 Q16 25 20 25 L20 42"
        fill="none" stroke="rgba(255,255,255,0.09)" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M12 6 L12 15 Q12 20 16 20"
        fill="none" stroke="rgba(255,255,255,0.09)" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M20 6 L20 15 Q20 20 16 20"
        fill="none" stroke="rgba(255,255,255,0.09)" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M34 6 Q42 6 42 14 Q42 21 36 22 L36 42"
        fill="none" stroke="rgba(255,255,255,0.09)" stroke-width="1.6" stroke-linecap="round"/>
    </pattern>
  </defs>

  <rect width="400" height="180" fill="#c45c2e"/>
  <rect width="400" height="180" fill="url(#rp-cutlery)"/>
  <rect width="400" height="180" fill="rgba(0,0,0,0.08)"/>

  <circle cx="200" cy="82" r="36" fill="rgba(0,0,0,0.15)"/>
  <circle cx="200" cy="82" r="34" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="1"/>

  <text x="200" y="76"
    font-family="Georgia, 'Times New Roman', serif"
    font-size="10" fill="rgba(255,255,255,0.55)"
    text-anchor="middle" letter-spacing="3">RESTRO</text>
  <text x="200" y="93"
    font-family="Georgia, 'Times New Roman', serif"
    font-size="15" fill="rgba(255,255,255,0.92)"
    text-anchor="middle" letter-spacing="4">PILOTS</text>

  <line x1="168" y1="103" x2="232" y2="103"
    stroke="rgba(255,255,255,0.25)" stroke-width="0.5"/>

  <text x="200" y="116"
    font-family="'Helvetica Neue', Arial, sans-serif"
    font-size="9" fill="rgba(255,255,255,0.45)"
    text-anchor="middle" letter-spacing="1.5">DISCOVER · DINE · DELIGHT</text>

  <rect x="0" y="150" width="400" height="30" fill="rgba(0,0,0,0.3)"/>
  <text x="200" y="169"
    font-family="'Helvetica Neue', Arial, sans-serif"
    font-size="11" fill="rgba(255,255,255,0.75)"
    text-anchor="middle" letter-spacing="0.3">Photos coming soon</text>
</svg>`;

const FALLBACK_DATA_URI = `data:image/svg+xml;utf8,${encodeURIComponent(FALLBACK_SVG)}`;

/**
 * Returns the canonical Restropilots brand placeholder data URI.
 * Accepts an optional id param (ignored) so existing call-sites
 * that pass doc._id don't need to change.
 *
 * @param {string} [_id] - ignored, kept for API compatibility
 * @returns {string} data:image/svg+xml URI
 */
export function getFallbackSvg(_id) {
  return FALLBACK_DATA_URI;
}

export default FALLBACK_DATA_URI;